import { h } from '@stencil/core';
import cn from 'classnames';
import { generateSrcSet, generateMedia, pesIconMirrorDirection, pesIconSizes } from '@pes-ui/utils';
export class BannerPromoBlock {
  constructor() {
    this.handleWatchClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.isShown = !this.isShown;
    };
    this.sdlCategoryPromo = undefined;
    this.isShown = false;
    this.isHover = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return (h("div", { class: "banner-promo-block", onMouseLeave: () => (this.isHover = false), onMouseEnter: () => (this.isHover = true), onClick: () => {
        var _a, _b, _c, _d;
        return window.open((_b = (_a = this.sdlCategoryPromo) === null || _a === void 0 ? void 0 : _a.callToAction[0]) === null || _b === void 0 ? void 0 : _b.externalUrl, ((_d = (_c = this.sdlCategoryPromo) === null || _c === void 0 ? void 0 : _c.callToAction[0]) === null || _d === void 0 ? void 0 : _d.openInNewWindow) ? '_blank' : '_self');
      } }, h("div", { class: "banner-promo-block__wrapper" }, h("div", { class: "banner-promo-block__image-wrap" }, h("picture", { class: "banner-promo-block__picture" }, (_c = (_b = (_a = this.sdlCategoryPromo) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.imageSourceSets) === null || _c === void 0 ? void 0 :
      _c.map(({ minWidth, maxWidth, urls }) => (h("source", { media: generateMedia(minWidth, maxWidth), srcSet: generateSrcSet(urls) }))), h("img", { src: (_e = (_d = this.sdlCategoryPromo) === null || _d === void 0 ? void 0 : _d.image) === null || _e === void 0 ? void 0 : _e.Url, alt: (_g = (_f = this.sdlCategoryPromo) === null || _f === void 0 ? void 0 : _f.image) === null || _g === void 0 ? void 0 : _g.altText }))), h("div", { class: "banner-promo-block__context" }, h("h4", null, (_h = this.sdlCategoryPromo) === null || _h === void 0 ? void 0 : _h.title), ((_j = this.sdlCategoryPromo) === null || _j === void 0 ? void 0 : _j.description) && (h("p", { class: "banner-promo-block__context-description" }, (_k = this.sdlCategoryPromo) === null || _k === void 0 ? void 0 : _k.description)), h("div", { class: "banner-promo-block__context-panel" }, (_l = this.sdlCategoryPromo) === null || _l === void 0 ? void 0 : _l.callToAction.map((action) => {
      return (action === null || action === void 0 ? void 0 : action.externalUrl) ? (h("div", { class: "banner-promo-block__context-panel-link" }, h("a", { class: cn('banner-promo-block__context-link', this.isHover && 'banner-promo-block__context-link_underline'), href: (action === null || action === void 0 ? void 0 : action.externalUrl) && (action === null || action === void 0 ? void 0 : action.externalUrl), target: (action === null || action === void 0 ? void 0 : action.openInNewWindow) ? '_blank' : '_self' }, action === null || action === void 0 ? void 0 : action.text), h("pes-icon", { class: "banner-promo-block__context-link-icon", size: pesIconSizes.NANO, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left"))) : (h("div", { class: "banner-promo-block__context-button-block" }, h("button", { onMouseLeave: () => (this.isHover = true), onMouseEnter: () => (this.isHover = false), onClick: this.handleWatchClick, class: "banner-promo-block__context-button" }, action === null || action === void 0 ? void 0 : action.text), h("span", { class: "banner-promo-block__context-icon-play" })));
    })))), this.isShown && (h("div", { class: "banner-promo-block__modal-window", onClick: this.handleWatchClick }, h("iframe", { class: "banner-promo-block__modal-window-content-video", width: "540", height: "360", src: (_m = this.sdlCategoryPromo) === null || _m === void 0 ? void 0 : _m.callToAction[1].youTubeEmbedUrl, title: "YouTube video player", frameborder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowfullScreen: "1" })))));
  }
  static get is() { return "pes-banner-promo-block"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["banner-promo-block.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["banner-promo-block.css"]
    };
  }
  static get properties() {
    return {
      "sdlCategoryPromo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TSDLPromoBlock",
          "resolved": "{ title: string; video?: any; description: string; image: Image; subtitle: string; youTubeEmbedUrl: string; callToAction: CallToAction; carouselSlideType: string; masterRangeId: string; rangeId?: string; }",
          "references": {
            "TSDLPromoBlock": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "isShown": {},
      "isHover": {}
    };
  }
  static get elementRef() { return "el"; }
}
